exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jumbotron{\r\n    background-color: #3279c1\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/homePC/angular-comp/yarukami/src/app/top/top.component.css
// module id = ../../../../../src/app/top/top.component.css
// module chunks = main